import { render, staticRenderFns } from "./MaterialItemInput.vue?vue&type=template&id=28674de6&scoped=true&"
import script from "./MaterialItemInput.vue?vue&type=script&lang=ts&"
export * from "./MaterialItemInput.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28674de6",
  null
  
)

export default component.exports